import {mapActions, mapState} from "pinia";
import {useGlobalsStore} from "@/stores/globals";

export const CommonMixins = {
  methods: {
    ...mapActions(useGlobalsStore, ['SetAnyState', 'ToggleChatUI']),
    SetState(target, value) {
      return this.SetAnyState({target, value})
    },
    OpenHelpWindow() {
      if (this.ConfigChatEnabled) {
        this.ToggleChatUI();
      }
    },
    FormSelector() {
      let the_copier = null;
      if (this.selected_copier) {
        the_copier = this.selected_copier;
      } else {
        if (this.cart_items.length > 0) {
          the_copier = this.cart_items[this.cart_items.length - 1].product;
        }
      }
      if (the_copier) {
        if (the_copier.manufacturer_id == 9) {
          this.SetState('active_form', 'mailing-form');
        } else if (the_copier.form_factor.toLowerCase() == 'wide-format') {
          this.SetState('active_form', 'wide-format-form');
        } else if (the_copier.printer_category.toLowerCase().includes('phone')) {
          this.SetState('active_form', 'phone-form');
        } else if (the_copier.printer_category.toLowerCase() == 'scanner') {
          this.SetState('active_form', 'scanner-form');
        } else {
          this.SetState('active_form', 'default-form');
        }
      }
    },
    SetAiAssistantConfig() {
      const AiAssistant = {...this.assistant}
      AiAssistant.config = window.ai_chat_config;
      AiAssistant.visible = false;
      this.SetState('assistant', AiAssistant);
    },
    ProductImage(product) {
      const path = import.meta.env.VITE_SERVERAPI_URL + '/storage/uploads/products/product-img'
      return `${path}/${product.product_image}`;
    },
  },
  computed: {
    ...mapState(useGlobalsStore, [
      'selected_copier',
      'cart_items',
      'assistant',
    ]),

    /* Configs settings.json */
    ConfigShopURL() {
      return 'https://1800toners.com'
    },
    ConfigTopbarColor() {
      if (typeof window.catalog_config.colors.topbar != "undefined") {
        return window.catalog_config.colors.topbar;
      } else {
        return "#ffffff";
      }
    },
    ConfigShowPricing() {
      if (window.catalog_config.show_pricing != undefined) {
        return window.catalog_config.show_pricing;
      } else {
        return false;
      }
    },
    ConfigModalsColor() {
      if (typeof window.catalog_config.colors.modals != "undefined") {
        return window.catalog_config.colors.modals;
      } else {
        return "#1565C0";
      }
    },
    ConfigSinglePageUrl() {
      if (window.catalog_config.single_page_url != undefined) {
        return window.catalog_config.single_page_url.replace(/\/$/, "");
        ;
      } else {
        return "/product";
      }
    },
    ConfigElementsColor() {
      if (window.catalog_config.colors.buttons != undefined) {
        return window.catalog_config.colors.buttons;
      } else {
        return "#1565C0";
      }
    },
    ConfigShowShopBanner() {
      if (window.catalog_config.show_shop_banner != undefined) {
        return window.catalog_config.show_shop_banner;
      } else {
        return false;
      }
    },
    ConfigShowFeaturedCards() {
      if (window.catalog_config.show_featured_cards != undefined) {
        return window.catalog_config.show_featured_cards;
      } else {
        return false;
      }
    },

    /* Configs from ai_chat.json */
    ConfigChatEnabled() {
      if (this.assistant.config && this.assistant.config.enabled) {
        return true;
      } else {
        return false;
      }
    },
  },
};
